// 打印相关接口
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB = "" } = e6ModuleOrderWaybillProcessApi;
/****************************打印相关***************************************/
// 获取打印模板列表
export function getPrintTemplate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/findPrintTemplate`,
    method: "post",
    data
  });
}
// 修改获取打印模板信息
export function getPrintTemplateSet(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/findPrintById`,
    method: "get",
    params
  });
}
// 修改打印模板
export function updatePrintTemplate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/update`,
    method: "post",
    data
  });
}
// 新增获取打印模板默认信息
export function getPrintDefaultSet(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/findFiled`,
    method: "get",
    params
  });
}
// 新增打印模板
export function addPrintTemplate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/save`,
    method: "post",
    data
  });
}
// 删除模板
export function delPrintTemplate(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/delete`,
    method: "get",
    params
  });
}
// 检查模板名称是否存在
export function checkPrintTemplateName(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/checkName`,
    method: "post",
    data
  });
}
// 获取订单打印页详情
export function getOrderPrintInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/findOrderByIds`,
    method: "post",
    data
  });
}
// 获取运单打印页详情
export function getWaybillPrintInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/print/findWayBillOrderById`,
    method: "post",
    data
  });
}
